import * as React from 'react';
import * as _ from 'lodash';
import * as qs from 'query-string';
import * as moment from 'moment';

import { Dispatch, connect } from 'react-redux';
import { Button, Glyphicon, FormControl } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Loader from 'react-spinners/ClockLoader';
import { downloadFile } from '@nkr/services/download-file';

import {
    ICenterDashListResponse, IDashLogListResponse, IDashCenterLookupDataResponse, IExpertSystemEnrollResponse, ICheckDonorProfileResponse, ICenterDashDetailResponse,
    IUploadLabsResponse
} from '@nkr/store/donor-intake/actions';
import {
    IDonorStatus, IBaseResponse, IListItem, IDonorRegistration, IDonorConnectEmailRequest, IDonorSearchRequest, IDonorDetailsRequest,
    IContact, ICoordinatorListByCenter, IDonorStatusByCenter, IDashRemoteStatus,
    IMicrositeRecipientForList, IConvertDonationType,
    IMicrositeConvertDonationType
} from '@nkr/models/index';
import { IDashWorkFlowStatusRequest } from '@nkr/models/dash-workflow-status-request';
import { OrganType } from '@nkr/enums/organ-type';
import { DashDonationType, DonationType } from '@nkr/enums/index';
import { IApplicationState, AppActionCreators, IAppState, MicrositeActionCreators, DashCenterActionCreators, IRecipientCoordListLookupDataResponse, CenterActionCreators, IReferralConfigResponse, DonorShieldDirectActionCreators, DonorSearchActionCreators, RecipientActionCreators } from '@nkr/store/index';
import { ICoordinator } from '../../coordinator';
import { DonorIntakeAction } from '../donor-intake-action';
import { AxiosError } from 'axios';
import Filters from './filters';
import {
    IDonorShieldInviteOutcome,
    donorShieldInviteNotSentMessage,
    shouldWarnDonorShieldInviteNotSent
} from '../donor-shield-invite-outcome';

import ViewDonorRegistration from '../view-donor-registration';
import ViewPreWorkUp from '../view-pre-workup';
import Drawer from 'rc-drawer';
import Grid from './grid';
import DonorConnectEmailConfirmation from '@nkr/views/dash/donor-connect/donor-connect-email-confirmation';
import MarkJugArrivedSendEmail from './mark-jug-arrived-send-email';
import ExpertSystemEnrollmentConfirm from '../expert-system-enrollment-confirm';
import ExpertSystemEnrollmentResponse from '../expert-system-enrollment-response';
import RecipientCenterCoordinatorConfirm from '../recipient-center-coordinator-confirm';

import UploadLabResults from '../../pwl/upload-lab-results-modal';
import ConvertToDirectToCenterModal from '../../pwl/convert-to-direct-to-center-modal';
import RestartPwlModal from '../../pwl/restart-pwl-modal';
import ExpireDonorModal from '../../pwl/expire-donor-modal';
import OptOutDonorModal from '../../pwl/opt-out-donor-modal';
import ReverseRuleOut from '../details/reverse-rule-out';
import RuleOutDonorModal from '../rule-out-donor-modal';
import GridPwl from './grid-pwl';
import DonorShieldInviteSentModal from '../donor-shield-invite-sent-modal';
import AdvancedReimbursementWorkupModal, { IAdvancedReimbursementSubmittedForm } from '../advanced-reimbursement-workup-modal';
import AdvancedReimbursementEnrolledScheduleModal from '../advanced-reimbursement-enrolled-schedule-modal';
import {
    advancedReimbursementNetworkPromptSnapshot,
    buildAdvancedReimbursementNetworkExtras,
    IAdvancedReimbursementNetworkPayload,
    isAdvancedReimbursementInviteFlowApplicable,
    isAdvancedReimbursementInviteMilestone,
    isEligibleForAdvancedReimbursementInvite,
    isEnrolledInAdvancedReimbursement,
    isPreOpScheduledWithFutureDate,
    isWorkupScheduledWithFutureDate,
    mergeAdvancedReimbursementIntoChangeStatusRequest,
    PRE_OP_SCHEDULED_REMOTE_STATUS_ID,
    shouldPromptAdvancedReimbursementEnrolledScheduleModal,
    shouldPromptAdvancedReimbursementNetworkModal,
    WORKUP_SCHEDULED_REMOTE_STATUS_ID
} from '../advanced-reimbursement-workflow';
import IntendedMicrositeRecipientModal from '../intended-microsite-recipient-modal';
import { ConversionType } from '@nkr/enums/conversion-type';

interface IProps {
    centerId: number,
    subSection: string,
    isAdminSection: boolean,
    isCenter: boolean
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getDonorDetails: (centerId: number, registrationId: number) => Promise<ICenterDashDetailResponse>,
    getAllDonorRegistrationList: (data: IDonorSearchRequest, isSuperAdmin: boolean) => Promise<ICenterDashListResponse>,
    getDonorRegistrationSearchIntendedList: (data: IDonorSearchRequest, isSuperAdmin: boolean) => Promise<ICenterDashListResponse>,
    getAllDonorRegistrationListExport: (data: IDonorSearchRequest) => Promise<ICenterDashListResponse>,
    getDonorCenterLogEntries: (centerId: number, regId: number, isAdmin: boolean) => Promise<IDashLogListResponse>,
    getLookupData: (centerId: number, isSuperAdmin: boolean) => Promise<IDashCenterLookupDataResponse>,
    getReferralConfig: (centerId: number) => Promise<IReferralConfigResponse>,
    changeStatus: (request: IDashWorkFlowStatusRequest) => Promise<IBaseResponse>,
    updateDonorRegistrationWorkflowStatus: (centerId: number, regId: number, statusId: number, centerNextFollowUpDate: string) => Promise<IBaseResponse>,
    updateDonorRegistrationNetworkStatus: (
        centerId: number,
        regId: number,
        remoteStatus: number | null,
        remoteStatusDate: string | null,
        onHoldStatusReason: string | null,
        extras?: IAdvancedReimbursementNetworkPayload | null
    ) => Promise<IBaseResponse>,
    searchArPerson: (centerId: number, firstName: string, lastName: string, birthDate: string, organType: number) => Promise<any>,
    searchArAliases: (centerId: number, donorAlias: string, recipientAlias: string, organType: number) => Promise<any>,
    searchArDonorPerson: (centerId: number, firstName: string, lastName: string, birthDate: string) => Promise<any>,
    changeAssignedCoordinator: (centerId: number, regId: number, contactId: number) => Promise<IBaseResponse>,
    unassignCoordinator: (centerId: number, regId: number) => Promise<IBaseResponse>,
    saveLogEntry: (centerId: number, dashRegistrationId: number, actionTaken: number, comments: string) => Promise<ICenterDashDetailResponse>,
    updateLogEntry: (id: number, centerId: number, dashRegistrationId: number, actionTaken: number, comments: string) => Promise<ICenterDashDetailResponse>,
    deleteLogEntry: (centerId: number, dashRegistrationId: number, id: number,) => Promise<ICenterDashDetailResponse>,
    sendConfirmEmail: (request: IDonorConnectEmailRequest) => Promise<IBaseResponse>,
    markJugAsArrived: (donorId: number, arrivalDate: string) => Promise<IBaseResponse>,
    updateDonorDetails: (id: number, detailRequest: IDonorDetailsRequest) => Promise<IBaseResponse>,
    updateComments: (id: number, detailRequest: IDonorDetailsRequest) => Promise<IBaseResponse>,
    updateDisposition: (id: number, detailRequest: IDonorDetailsRequest) => Promise<IBaseResponse>,
    enrollExpertSystem: (registrationId: number, bulkType: number, alias: string, medicalRecordId: number) => Promise<IExpertSystemEnrollResponse>,
    checkDonorProfile: (registrationId: number) => Promise<ICheckDonorProfileResponse>,
    getLabResultsNotCombined: (registrationId: number) => Promise<any>,
    getLabResultsCombined: (registrationId: number) => Promise<any>,
    sendPediatricGalleryEmail: (centerId: number, registrationId: number) => Promise<IBaseResponse>,
    donorDetailsPrint: (centerId: number, registrationId: number) => Promise<any>,
    handleLoginAs: (registrationId: number) => Promise<any>,
    validateExpertSystemEnrollment: (registrationId: number, alias: string) => Promise<IBaseResponse>
    getRecipientCenterCoordList: (centerId: number) => Promise<IRecipientCoordListLookupDataResponse>,
    updateRecipientCenterCoord: (centerId: number, donorId: number, coordinatorId: number) => Promise<IBaseResponse>,
    getLabOrder: (registrationId: number) => Promise<any>,
    uploadLabs: (registrationId: number, file: File) => Promise<IUploadLabsResponse>,
    convertToDirectToCenter: (registrationId: number, centerId: number) => Promise<IBaseResponse>,
    restartPwl: (registrationId: number, isCystatinC: boolean) => Promise<IBaseResponse>,
    expireDonor: (registrationId: number, centerId: number) => Promise<ICenterDashDetailResponse>,
    optOutDonor: (registrationId: number, centerId: number) => Promise<ICenterDashDetailResponse>,
    reverseRuleOut: (registrationId: number) => Promise<ICenterDashDetailResponse>,
    getPedsMicrositeByCenter: (centerId: number) => Promise<any>,
    convertDonor: (data: any) => Promise<any>
}

type TProps = IProps & IStateProps & IDispatchProps;

interface IValidation {
    birthDate: boolean,
    centerWorkFlowIdValid: boolean,
    centerNextFollowupDateValid: boolean,
    coordinatorIdValid: boolean
}

export interface ISearch {
    id: number,
    showAdvancedSearch: boolean,
    showMoreOptions: boolean,
    filters: IDonorSearchRequest
}

interface IState {
    list: IDonorRegistration[],
    pedsList: IMicrositeRecipientForList[],
    statusListByCenter: IDonorStatusByCenter[],
    statusListForCenter: IDonorStatus[],
    stateList: IListItem[],
    actionList: IListItem[],
    dispositionList: IListItem[],
    remoteStatusList: IDashRemoteStatus[],
    donationTypeList: IListItem[],
    coordinatorListByCenter: ICoordinatorListByCenter[],
    coordinatorListForCenter: ICoordinator[],
    referDonorToNkr: boolean,
    ruleOutReasons: IListItem[],
    fetching: boolean,
    search: ISearch,
    view: {
        show: boolean,
        data: IDonorRegistration
    },
    viewPersistedCoordinatorId: number | null,
    confirmView: {
        show: boolean,
        formData: IDonorRegistration,
        jugArrivalDate: string
    },
    uploadLabResults: {
        show: boolean,
        data: IDonorRegistration
    },
    convertToDirectCenter: {
        show: boolean,
        data: IDonorRegistration
    },
    restartPwl: {
        show: boolean,
        data: IDonorRegistration,
        isCystatinC: boolean
    },
    expireDonor: {
        show: boolean,
        data: IDonorRegistration
    },
    optOutDonor: {
        show: boolean,
        data: IDonorRegistration
    },
    ruleOut: {
        show: boolean,
        data: IDonorRegistration
    },
    reverseRuleOut: {
        show: boolean,
        data: IDonorRegistration
    },
    mentorConfirmView: {
        show: boolean,
        data: IDonorRegistration
    },
    confirmExpertSystemEnrollment: {
        show: boolean,
        formData: IDonorRegistration,
        error: string,
        existingDonorAlias: string | null
    },
    confirmExpertSystemResponse: {
        show: boolean,
        donorId: number,
        useBulkKit: number,
        existingTyping: boolean,
        existingRequestForTyping: boolean,
        existingSwabMessage?: string,
        alias: string
    },
    confirmTransferDonor: {
        show: boolean,
        formData: IDonorRegistration,
        coordinatorList: IContact[],
        coordinatorId: number
    },
    donorShieldInviteSent: {
        show: boolean,
        donorName: string
    },
    intendedMicrositeRecipient: {
        show: boolean,
        donorData: IDonorRegistration
    },
    drawerAdvancedReimbursementWorkupModalOpen: boolean,
    drawerAdvancedReimbursementEnrolledScheduleModalOpen: boolean,
    drawerArDeclinedNetworkSnapshot: string | null,
    statusFormBaselineKey: number,
    validation: {
        birthDate: boolean,
        centerWorkFlowIdValid: boolean,
        centerNextFollowupDateValid: boolean,
        coordinatorIdValid: boolean
    },
    messages: string[]
}

class AllDonors extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        pedsList: [],
        statusListByCenter: [],
        statusListForCenter: [],
        stateList: [],
        actionList: [],
        dispositionList: [],
        remoteStatusList: [],
        donationTypeList: [],
        coordinatorListByCenter: [],
        coordinatorListForCenter: [],
        referDonorToNkr: false,
        ruleOutReasons: [],
        fetching: false,
        search: {
            id: 0,
            showAdvancedSearch: false,
            showMoreOptions: false,
            filters: {
                centerId: 0,
                firstName: '',
                lastName: '',
                alias: '',
                email: '',
                dateOfBirth: '',
                includeNkr: true,
                includeDash: true,
                includeMiSite: true,
                showFilter: 0,
                dateSearchType: 0,
                filterStartDate: '',
                filterEndDate: '',
                disposition: -1,
                centerStatus: -1,
                isInEmr: 0,
                coordinatorId: -1,
                organType: -1,
                followUpDays: null,
                isLostInPwl: null,
                stopCommunication: null,
                connectToDonorIsDesired: null,
                referralStatus: null,
                livingDonorPrioritization: false,
                referred: false,
                donated: false,
                includeAllMs: false,
                excludeTransferredAndDuplicate: false,
                micrositeRecipientId: null
            }
        },
        view: {
            show: false,
            data: null
        },
        viewPersistedCoordinatorId: null,
        confirmView: {
            show: false,
            formData: null,
            jugArrivalDate: moment().format('YYYY-MM-DD')
        },
        mentorConfirmView: {
            show: false,
            data: null
        },
        uploadLabResults: {
            show: false,
            data: null
        },
        convertToDirectCenter: {
            show: false,
            data: null
        },
        restartPwl: {
            show: false,
            data: null,
            isCystatinC: false
        },
        expireDonor: {
            show: false,
            data: null
        },
        optOutDonor: {
            show: false,
            data: null
        },
        ruleOut: {
            show: false,
            data: null
        },
        reverseRuleOut: {
            show: false,
            data: null
        },
        confirmExpertSystemEnrollment: {
            show: false,
            formData: null,
            error: '',
            existingDonorAlias: null
        },
        confirmExpertSystemResponse: {
            show: false,
            donorId: -1,
            useBulkKit: -1,
            existingTyping: false,
            existingRequestForTyping: false,
            alias: ''
        },
        confirmTransferDonor: {
            show: false,
            formData: null,
            coordinatorList: null,
            coordinatorId: -1
        },
        donorShieldInviteSent: {
            show: false,
            donorName: ''
        },
        intendedMicrositeRecipient: {
            show: false,
            donorData: null
        },
        drawerAdvancedReimbursementWorkupModalOpen: false,
        drawerAdvancedReimbursementEnrolledScheduleModalOpen: false,
        drawerArDeclinedNetworkSnapshot: null,
        statusFormBaselineKey: 0,
        validation: {
            birthDate: true,
            centerWorkFlowIdValid: true,
            centerNextFollowupDateValid: true,
            coordinatorIdValid: true
        },
        messages: []
    }

    container: HTMLDivElement;
    intervalId: any;

    componentDidMount = () => {
        this.setState({
            fetching: false,
        }, () => {
            this.getData(true);
        });
    }

    getData = (isFirstLoad: boolean) => {
        let start = isFirstLoad ? this.props.showLoading('Loading, one moment please...') : Promise.resolve(null);
        let parsed = qs.parse(location.search);
        let showAdv = isFirstLoad && parsed.adv == '1' || null;
        let search = this.getDefaultFilters(showAdv);
        let queryOnLoad = this.props.subSection == "TO-DO" || location.search != '';

        if (parsed.livingDonorPrioritization == 1) {
            search.filters.livingDonorPrioritization = true;
        }

        if (parsed.referred == 1) {
            search.filters.referred = true;
            search.filters.filterStartDate = parsed.sd;
            search.filters.filterEndDate = parsed.ed;
        }

        if (parsed.donated == 1) {
            search.filters.donated = true;
            search.filters.filterStartDate = parsed.sd;
            search.filters.filterEndDate = parsed.ed;
        }

        if (parsed.includeAllMs == 1) {
            search.filters.includeAllMs = true;
        }

        if (parsed.xtd == 1) {
            search.filters.excludeTransferredAndDuplicate = true;
        }

        if (parsed.donated == 1 || parsed.referred == 1 || parsed.organType != null) {
            if (parsed.organType == 1) {
                search.filters.organType = 0;
            }

            if (parsed.organType == 2) {
                search.filters.organType = 1;
            }

            if (parsed.organType == 3) {
                search.filters.organType = -1;
            }
        } else if (parsed.organ == null) {
            search.filters.organType = this.props.app.site.organType == OrganType.Kidney ? 0 : 1;
        }

        if (parsed.micrositeRecipientId) {
            search.filters.micrositeRecipientId = parseInt(parsed.micrositeRecipientId);
        } else {
            search.filters.micrositeRecipientId = null;
        }

        start.then(() => {
            this.setState({
                fetching: isFirstLoad == true ? false : true,
                search
            }, () => {
                // fetched independently so a slow donor query doesn't delay showing the Universal DASH Center toggle
                this.props.getReferralConfig(this.props.centerId).then(referralConfigResponse => {
                    this.setState({
                        referDonorToNkr: referralConfigResponse?.data?.success ? referralConfigResponse.data.results.referDonorToNkr : false
                    });
                });

                Promise.all([
                    queryOnLoad ? this.getAllRegistrationsList({ ...search.filters, maxResults: this.props.subSection == 'TO-DO' ? 20 : null }) : Promise.resolve(null), // only pre-load the to-do page
                    this.props.getLookupData(this.props.centerId, this.props.isAdminSection),
                    this.props.getPedsMicrositeByCenter(this.props.centerId)
                ])
                    .then(([listResponse, lookupDataResponse, pedsMicrositeResponse]) => {
                        if (lookupDataResponse.data.success) {
                            let list = listResponse?.data?.results || [];
                            let pedsList = pedsMicrositeResponse?.data?.results.list || [];
                            let { statusListByCenter, stateList, actionList, donationTypeList, remoteStatusList, dispositionList, coordinatorListByCenter, ruleOutReasons } = lookupDataResponse.data.results;

                            let coordinatorListForCenter = this.props.isAdminSection ? [] : coordinatorListByCenter.find(x => x.centerId == this.props.centerId)?.list;
                            let statusListForCenter = this.props.isAdminSection ? [] : statusListByCenter.find(x => x.centerId == this.props.centerId)?.listItems;

                            this.setState({
                                list,
                                pedsList,
                                statusListForCenter,
                                stateList,
                                actionList,
                                dispositionList,
                                remoteStatusList,
                                donationTypeList,
                                coordinatorListForCenter,
                                ruleOutReasons,
                                fetching: false
                            }, () => {
                                if (search.id > 0) {
                                    this.handleViewRegistration(search.id);
                                }
                            });
                        }
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    refreshData = () => {
        this.props.showLoading('Refreshing, one moment please...').then(() => {
            this.getAllRegistrationsList(this.state.search.filters).then(response => {
                let list = response?.data?.results || [];
                this.setState({
                    list
                }, () => {
                    if (this.state.search.id > 0) {
                        this.handleViewRegistration(this.state.search.id);
                    }
                });
            })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    getDefaultFilters = (showAdvancedSearch: boolean | null = null): ISearch => {
        let isToDo = this.props.subSection != "ALL";
        let parsed = qs.parse(location.search);

        showAdvancedSearch = showAdvancedSearch ?? this.state.search.showAdvancedSearch;

        return {
            id: parsed.id || 0,
            showAdvancedSearch,
            showMoreOptions: parsed.mo == '1',
            filters: {
                centerId: this.props.centerId,
                firstName: parsed.f || '',
                lastName: parsed.l || '',
                alias: parsed.a || '',
                email: parsed.e || '',
                dateOfBirth: parsed.dob || '',
                includeNkr: parsed.nkr != '0',
                includeDash: parsed.dash != '0',
                includeMiSite: parsed.ms != '0',
                filterStartDate: showAdvancedSearch ? parsed.sd || moment().subtract(12, 'month').format('YYYY-MM-DD') : '',
                filterEndDate: showAdvancedSearch ? parsed.ed || moment().format('YYYY-MM-DD') : '',
                disposition: parsed.d || -1,
                dateSearchType: parsed.s || 0,
                showFilter: parsed.fltr || 0,
                centerStatus: parsed.stat || -1,
                isInEmr: parsed.emr || 0,
                coordinatorId: localStorage.getItem('dashCoordinator') != null && localStorage.getItem('dashCoordinator') !== '' ? parseInt(localStorage.getItem('dashCoordinator')) : -1,
                organType: parsed.organ != null
                    ? parseInt(parsed.organ)
                    : parsed.organType != null
                        ? parsed.organType == 1 ? 0 : parsed.organType == 2 ? 1 : -1
                        : (this.props.app.site.organType == OrganType.Kidney ? 0 : 1),
                followUpDays: isToDo && !this.props.isAdminSection ? 7 : null,
                isLostInPwl: null, //isToDo && this.props.isAdminSection ? true : null,
                stopCommunication: (isToDo && this.props.isAdminSection ? 0 : null),
                connectToDonorIsDesired: null,
                referralStatus: isToDo ? 1 : (parsed.rs != null ? parseInt(parsed.rs) : null),
                livingDonorPrioritization: false,
                referred: false,
                donated: false,
                includeAllMs: false,
                excludeTransferredAndDuplicate: false,
                micrositeRecipientId: null
            }
        };
    }

    getIsAdvancedSearch = (): boolean => {
        let parsed = qs.parse(location.search);
        return parsed.adv == '1' || parsed.livingDonorPrioritization == 1;
    }

    addUrlParam = (params: URLSearchParams, key: string, value: string | number | boolean) => {
        if (value !== null && value !== undefined && value !== '') {
            if (typeof value === 'boolean') {
                params.append(key, value ? '1' : '0');
            } else {
                params.append(key, value.toString());
            }
        }
    }

    setUrlParameters = (search: ISearch, centerView: boolean) => {
        let isToDo = this.props.subSection != "ALL";
        let params = new URLSearchParams();

        let {
            firstName, lastName, alias, email, dateOfBirth,
            includeNkr, includeDash, includeMiSite,
            filterStartDate, filterEndDate,
            disposition, dateSearchType, showFilter, centerStatus, isInEmr, livingDonorPrioritization,
            referred, donated, includeAllMs, organType, referralStatus, excludeTransferredAndDuplicate
        } = search.filters;

        this.addUrlParam(params, "id", search.id.toString() || null);
        this.addUrlParam(params, "adv", search.showAdvancedSearch ? '1' : '0');
        this.addUrlParam(params, "mo", search.showMoreOptions ? '1' : null);
        this.addUrlParam(params, "f", firstName || null);
        this.addUrlParam(params, "l", lastName || null);
        this.addUrlParam(params, "a", alias || null);
        this.addUrlParam(params, "e", email || null);
        this.addUrlParam(params, "dob", dateOfBirth || null);
        this.addUrlParam(params, "nkr", includeNkr === false ? '0' : '1');
        this.addUrlParam(params, "dash", includeDash === false ? '0' : '1');
        this.addUrlParam(params, "ms", includeMiSite === false ? '0' : '1');
        this.addUrlParam(params, "sd", filterStartDate || null);
        this.addUrlParam(params, "ed", filterEndDate || null);
        this.addUrlParam(params, "d", disposition || null);
        this.addUrlParam(params, "s", dateSearchType || null);
        this.addUrlParam(params, "fltr", showFilter || null);
        this.addUrlParam(params, "stat", centerStatus || null);
        this.addUrlParam(params, "emr", isInEmr || null);
        this.addUrlParam(params, 'organ', organType != null && organType != -1 ? organType : null);
        this.addUrlParam(params, 'rs', referralStatus != null ? referralStatus : null);
        this.addUrlParam(params, 'livingDonorPrioritization', livingDonorPrioritization == true ? 1 : null);
        this.addUrlParam(params, 'referred', referred == true ? 1 : null);
        this.addUrlParam(params, 'donated', donated == true ? 1 : null);
        this.addUrlParam(params, 'includeAllMs', includeAllMs == true ? 1 : null);
        this.addUrlParam(params, 'xtd', excludeTransferredAndDuplicate == true ? 1 : null);

        let urlPrefix = this.props.isAdminSection ? "/admin/dash/donor-intake" : `/center/${this.props.centerId}/donors/donor-intake`;

        let newUrl = isToDo
            ? `${urlPrefix}/to-do?${params.toString()}`
            : `${urlPrefix}/search?${params.toString()}`

        window.history.pushState({}, '', newUrl);
    }

    saveContainer = (container: HTMLDivElement) => {
        this.container = container;
    };

    getContainer = () => {
        return this.container;
    };

    validate = () => {
        let { birthDate, centerNextFollowUpDate, centerWorkflowId } = this.state.view.data;
        const requiresFollowUp = this.state.statusListForCenter.find(item => item.id == centerWorkflowId)?.requiresFollowUp;

        let validation: IValidation = {
            birthDate: birthDate != '',
            centerWorkFlowIdValid: centerWorkflowId != -1,
            centerNextFollowupDateValid: !requiresFollowUp || (centerNextFollowUpDate != null && centerNextFollowUpDate != '' && moment(centerNextFollowUpDate, 'MM/DD/YYYY', true).isValid()),
            coordinatorIdValid: true
        };

        let messages: string[] = [];

        if (!birthDate) {
            messages.push('Birth date must not be blank');
            validation.birthDate = false;
        } else {
            let parsedBirthDate = moment(birthDate, 'MM/DD/YYYY', true);
            if (!parsedBirthDate.isValid()) {
                messages.push('Birth date is not valid');
                validation.birthDate = false;
            } else {
                let today = moment();
                let age = today.diff(parsedBirthDate, 'years');

                if (age < 18 || age > 100) {
                    messages.push('Birth date must be between 18 and 100 years ago');
                    validation.birthDate = false;
                }
            }
        }

        return {
            validation,
            messages
        };
    }

    validateRecipientCenterConfirm = () => {
        let confirmTransferDonor = this.state.confirmTransferDonor;

        let validation: IValidation = {
            birthDate: true,
            centerWorkFlowIdValid: true,
            centerNextFollowupDateValid: true,
            coordinatorIdValid: confirmTransferDonor.coordinatorId != -1 && confirmTransferDonor.coordinatorId != null
        };

        return {
            validation
        };
    }

    getAllRegistrationsList = (filters) => {
        if (this.props.subSection == "SEARCH-INTENDED") {
            return this.props.getDonorRegistrationSearchIntendedList(filters.centerId, this.props.isAdminSection);
        }
        else {
            return this.props.getAllDonorRegistrationList(filters, this.props.isAdminSection);
        }
    }

    handleItemSelected = (id: number, action: DonorIntakeAction) => {
        let data = this.state.list.find(x => x.id == id);

        switch (action) {
            case DonorIntakeAction.ConnectWithDonorMentor:
                this.setState({
                    mentorConfirmView: {
                        show: true,
                        data
                    }
                });

                break;

            case DonorIntakeAction.StartExpertSystem:
                this.handleShowExpertSystemEnrollment(data.id);
                break;

            case DonorIntakeAction.LabResults:
                this.handleGetLabResults(data.id);
                break;

            case DonorIntakeAction.ViewLabResultsDataGenerated:
                this.handleGetLabResultsCombined(data.id);
                break;

            case DonorIntakeAction.GetPdf:
                this.handleDonorDetailsDownload(data.id);
                break;

            case DonorIntakeAction.CompleteForCandidate:
                this.handleLoginAs(data.id);
                break;

            case DonorIntakeAction.ApplyForDonorShieldReimbursement:
                this.handleApplyForDonorShield(data);
                break;

            case DonorIntakeAction.TransferDonor:
                let { recipientCenterId, id: donorId, dashDomain, donorEditKey } = data;

                if ((data.type == 'SV' || data.type == 'DD') && recipientCenterId > 0) {
                    this.handleShowTransferDonor(recipientCenterId, data.id);
                } else {
                    window.location.href = `${dashDomain}/register/transfer-donor/${donorId}/${donorEditKey}`;
                }
                break;

            case DonorIntakeAction.ViewLabOrders:
                this.handleGetLabOrders(data.id);
                break;

            case DonorIntakeAction.UploadLabs:
                this.handleShowUploadLabResults(data.id);
                break;

            case DonorIntakeAction.ConvertToDirectToCenter:
                this.handleShowConfirmConvertToDirectToCenter(data.id);
                break;

            case DonorIntakeAction.RestartPwlJug:
                this.handleShowConfirmRestartPwl(data.id, false);
                break;

            case DonorIntakeAction.RestartPwlCystatinC:
                this.handleShowConfirmRestartPwl(data.id, true);
                break;

            case DonorIntakeAction.ExpireDonor:
                this.handleShowConfirmExpireDonor(data.id);
                break;

            case DonorIntakeAction.OptOutDonor:
                this.handleShowConfirmOptOutDonor(data.id);
                break;

            case DonorIntakeAction.RuleOut:
                this.handleConfirmRuleOut(data.id);
                break;

            case DonorIntakeAction.ReverseRuleOut:
                this.handleConfirmReverseRuleOut(data.id);
                break;

            case DonorIntakeAction.SendPediatricGalleryEmail:
                this.handleSendPediatricGalleryEmail(data);
                break;

            case DonorIntakeAction.AddIntendedMicrositeRecipient:
                this.handleShowConfirmIntendedMicrositeModal(data);
                break;
        }
    }

    handleApplyForDonorShield = (data: IDonorRegistration) => {
        if (!isEligibleForAdvancedReimbursementInvite(data)) {
            toast.info('This donor already has a Donor Shield profile or is not eligible for Advanced Reimbursement.');
            return;
        }

        this.props.showLoading('Opening donor details, one moment please...').then(() => {
            this.props.getDonorCenterLogEntries(this.props.centerId, data.id, this.props.isAdminSection)
                .then(response => {
                    if (!response.data.success) {
                        toast.error('Unable to open donor details.');
                        return;
                    }

                    const selected = _.cloneDeep(this.state.list).find(x => x.id == data.id);
                    if (!selected) {
                        toast.error('Unable to locate donor details.');
                        return;
                    }

                    if (!isEligibleForAdvancedReimbursementInvite(selected)) {
                        toast.info('This donor already has a Donor Shield profile or is not eligible for Advanced Reimbursement.');
                        return;
                    }

                    selected.logs = response.data.results;
                    selected.donorShieldInvitePendingWorkup = true;

                    this.setState({
                        view: {
                            show: true,
                            data: selected
                        }
                    }, () => {
                        const search = _.cloneDeep(this.state.search);
                        search.id = data.id;
                        this.setUrlParameters(search, false);
                    });
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleCloseDonorShieldInviteSent = () => {
        this.setState({
            donorShieldInviteSent: {
                show: false,
                donorName: ''
            }
        });
    }

    handleDonorDetailsDownload = (id: number) => {
        this.props.showLoading('Downloading Donor Details, one moment please...').then(() => {
            this.props.donorDetailsPrint(this.props.centerId, id).then((response: any) => {
                downloadFile(response.data, `dcn-donor-details.pdf`, 'application/pdf');
            }).finally(() => {
                this.props.hideLoading();
            });
        });
    };

    handleLoginAs = (id: number) => {
        this.props.showLoading('Getting Login Link, one moment please...').then(() => {
            this.props.handleLoginAs(id).then((response: any) => {
                if (response.data.success) {
                    const loginUrl = response.data.payload;
                    const newTab = window.open(loginUrl, '_blank');

                    if (!newTab) {
                        window.location.href = loginUrl;
                    }
                }
                else {
                    toast.error('Unable to get login link for donor.');
                }
            }).finally(() => {
                this.props.hideLoading();
            });
        });
    }

    handleCancelView = () => {
        this.setState({
            view: {
                show: false,
                data: null
            },
            viewPersistedCoordinatorId: null,
            drawerAdvancedReimbursementWorkupModalOpen: false,
            drawerAdvancedReimbursementEnrolledScheduleModalOpen: false,
            drawerArDeclinedNetworkSnapshot: null
        }, () => {
            let search = { ...this.state.search, id: 0 }

            this.setUrlParameters(search, false);
        });
    }

    handleSendEmail = () => {
        let { id: regId, email } = this.state.mentorConfirmView.data;

        let request: IDonorConnectEmailRequest = {
            regId,
            centerId: this.props.centerId,
            toEmail: email,
            replyToEmail: "",
            donorEmail: '',
            emailSent: true,
            emailSentDate: null,
            subject: "",
            content: ""
        };

        this.setState({
            mentorConfirmView: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Sending Email, one moment please...').then(() => {
                this.props.sendConfirmEmail(request)
                    .then(response => {
                        toast.success('Email sent successfully');
                    })
                    .catch((error: AxiosError) => {
                        toast.error("Unable to complete request: " + error.response.data);
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
                ;
            });
        });
    }

    handlePwlStatusChange = (registration: IDonorRegistration) => {
        let validateRecord = this.validate();
        let { centerId } = this.state.view.data

        this.setState({
            validation: {
                birthDate: validateRecord.validation.birthDate,
                centerWorkFlowIdValid: validateRecord.validation.centerWorkFlowIdValid,
                centerNextFollowupDateValid: validateRecord.validation.centerNextFollowupDateValid,
                coordinatorIdValid: true
            }
        }, () => {
            let { centerNextFollowupDateValid, centerWorkFlowIdValid } = validateRecord.validation;
            let valid = centerNextFollowupDateValid && centerWorkFlowIdValid;

            if (!registration.centerNextFollowUpDate) {
                registration.centerNextFollowUpDate = null;
            }

            if (valid) {
                this.props.showLoading('Changing status, one moment please...').then(() => {
                    const request: IDashWorkFlowStatusRequest = {
                        centerId: this.props.centerId,
                        registrationId: registration.id,
                        statusId: registration.centerWorkflowId || -1,
                        centerNextFollowUpDate: registration.centerNextFollowUpDate || null,
                        reviewComments: registration.reviewComments || null,
                        remoteStatus: registration.remoteStatus || null,
                        onHoldStatusReason: registration.onHoldStatusReason || null,
                        remoteStatusDate: registration.remoteStatusDate || null,
                        ruleOutReasonId: null,
                        allowReRegistration: null,
                        useNkrAssistance: null,
                        coordinatorName: null,
                        phoneNumber: null,
                        medicalReasonCategory: null,
                        medicalReasonNotes: null
                    };

                    this.props.changeStatus(request).then(async response => {
                        try {
                            if (response.data.success) {
                                const inviteOutcome = (response?.data?.results || {}) as IDonorShieldInviteOutcome;
                                const refreshed = await this.refreshRegistrationAfterStatusUpdate(registration.id);
                                if (!refreshed) {
                                    toast.error('Status changed, but unable to refresh donor details.');
                                    return;
                                }
                                if (shouldWarnDonorShieldInviteNotSent(inviteOutcome)) {
                                    toast.warn(donorShieldInviteNotSentMessage(inviteOutcome));
                                    return;
                                }
                                toast.success('Status changed successfully');
                            }
                        } finally {
                            this.props.hideLoading();
                        }
                    });
                });
            }
        })
    }

    handleStatusChange = async (request: IDashWorkFlowStatusRequest) => {
        const { centerId, showLoading, hideLoading } = this.props;

        try {
            await showLoading('Updating, one moment please...');

            const currentRegistration = this.state.list.find(item => item.id === request.registrationId);
            const regForAr = currentRegistration
                ? {
                    ...currentRegistration,
                    remoteStatus: request.remoteStatus ?? currentRegistration.remoteStatus,
                    remoteStatusDate: request.remoteStatusDate ?? currentRegistration.remoteStatusDate
                }
                : null;
            let changeStatusRequest = request;
            if (regForAr && isAdvancedReimbursementInviteMilestone(regForAr)) {
                changeStatusRequest = mergeAdvancedReimbursementIntoChangeStatusRequest(
                    request,
                    regForAr,
                    this.state.view.show && this.state.view.data?.id === request.registrationId
                        ? this.state.drawerArDeclinedNetworkSnapshot
                        : null
                );
            }

            let response = await this.props.changeStatus(changeStatusRequest);

            if (!response?.data?.success) {
                toast.error('Update failed');
                return;
            }

            const inviteOutcome = (response?.data?.results || {}) as IDonorShieldInviteOutcome;
            const donorShieldInviteSucceeded = !!inviteOutcome.inviteSent;

            const refreshed = await this.refreshRegistrationAfterStatusUpdate(request.registrationId);
            if (!refreshed) {
                toast.error('Status changed, but unable to refresh donor details.');
                return;
            }

            if (donorShieldInviteSucceeded) {
                this.setState({
                    donorShieldInviteSent: {
                        show: true,
                        donorName: refreshed.fullName || ''
                    }
                });
            }

            if (shouldWarnDonorShieldInviteNotSent(inviteOutcome)) {
                toast.warn(donorShieldInviteNotSentMessage(inviteOutcome));
                return;
            }
            toast.success('Updated successfully');
        } catch (err) {
            toast.error((err as Error)?.message ?? 'Unexpected error');
        } finally {
            hideLoading();
        }
    }

    refreshRegistrationAfterStatusUpdate = async (regId: number): Promise<IDonorRegistration | null> => {
        const { centerId, isAdminSection } = this.props;
        try {
            const logResponse = await this.props.getDonorCenterLogEntries(centerId, regId, isAdminSection);
            const donorResponse = await this.props.getDonorDetails(centerId, regId);
            if (!donorResponse?.data?.success) {
                return null;
            }
            const refreshed = _.cloneDeep(donorResponse.data.results) as IDonorRegistration;
            refreshed.logs = logResponse?.data?.results ?? refreshed.logs ?? [];
            this.setState(prev => {
                const nextList = prev.list.map(item => item.id === regId ? refreshed : item);
                const isViewingSame = !!prev.view?.show && prev.view.data?.id === regId;
                return {
                    list: nextList,
                    view: isViewingSame ? { ...prev.view, data: refreshed } : prev.view,
                    statusFormBaselineKey: prev.statusFormBaselineKey + 1,
                    viewPersistedCoordinatorId: isViewingSame
                        ? Number(refreshed.coordinatorId ?? 0)
                        : prev.viewPersistedCoordinatorId
                };
            });
            return refreshed;
        } catch {
            return null;
        }
    };

    buildDrawerCommentRequest = (d: IDonorRegistration): IDonorDetailsRequest => ({
        id: d.id,
        disposition: '',
        dispositionId: 0,
        comments: d.reviewComments || '',
        closeLoopSurgeryDateTime: '',
        closeLoopEntityTypeId: 0,
        closeLoopEntityType: 0,
        firstName: '',
        lastName: '',
        birthDate: '',
        phoneNumber: '',
        email: '',
        addressLine1: '',
        donorCity: '',
        donorState: '',
        donorStateId: 0,
        donorPostalCode: ''
    });

    handleSaveCenterCardDrawer = async () => {
        const { centerId, showLoading, hideLoading } = this.props;
        const reg = this.state.view.data;
        const previousCoordinatorId = Number(this.state.viewPersistedCoordinatorId ?? reg.coordinatorId ?? 0);
        const nextCoordinatorId = Number(reg.coordinatorId ?? 0);
        await showLoading('Saving, one moment please...');
        try {
            if (nextCoordinatorId !== previousCoordinatorId) {
                const coordinatorResponse = nextCoordinatorId > 0
                    ? await this.props.changeAssignedCoordinator(centerId, reg.id, nextCoordinatorId)
                    : await this.props.unassignCoordinator(centerId, reg.id);
                if (!coordinatorResponse?.data?.success) {
                    toast.error('Coordinator update failed');
                    return;
                }
            }
            const wf = await this.props.updateDonorRegistrationWorkflowStatus(centerId, reg.id, reg.centerWorkflowId ?? -1, reg.centerNextFollowUpDate || '');
            if (!wf?.data?.success) {
                toast.error('Workflow update failed');
                return;
            }
            const cm = await this.props.updateComments(centerId, this.buildDrawerCommentRequest(reg));
            if (!cm?.data?.success) {
                toast.error('Comments update failed');
                return;
            }
            const refreshed = await this.refreshRegistrationAfterStatusUpdate(reg.id);
            if (!refreshed) {
                toast.error('Saved, but unable to refresh donor details.');
                return;
            }
            toast.success('Saved');
        } catch {
            toast.error('Save failed');
        } finally {
            hideLoading();
        }
    };

    handleSaveNetworkCardDrawer = async () => {
        const reg = this.state.view.data;
        if (!reg) {
            return;
        }
        if (shouldPromptAdvancedReimbursementNetworkModal(reg, this.state.drawerArDeclinedNetworkSnapshot)) {
            this.setState({ drawerAdvancedReimbursementWorkupModalOpen: true });
            return;
        }
        if (shouldPromptAdvancedReimbursementEnrolledScheduleModal(reg)) {
            this.setState({ drawerAdvancedReimbursementEnrolledScheduleModalOpen: true });
            return;
        }
        await this.executeDrawerSaveNetworkCardWithExtras();
    };

    executeDrawerSaveNetworkCardWithExtras = async (
        inviteExplicit?: 'yes' | 'no',
        form?: IAdvancedReimbursementSubmittedForm | null
    ) => {
        const { centerId, showLoading, hideLoading } = this.props;
        const reg = this.state.view.data;
        if (!reg) {
            return;
        }
        const extrasRaw = buildAdvancedReimbursementNetworkExtras(reg, this.state.drawerArDeclinedNetworkSnapshot, inviteExplicit, inviteExplicit === 'yes' ? form ?? undefined : undefined);
        const extrasPayload = Object.keys(extrasRaw).length ? extrasRaw : null;
        const applyFlag = extrasPayload?.applyForDonorShieldAdvancedReimbursement;
        const inviteFlowApplicable = isAdvancedReimbursementInviteFlowApplicable(reg, applyFlag);

        await showLoading('Saving, one moment please...');
        try {
            const response = await this.props.updateDonorRegistrationNetworkStatus(centerId, reg.id, reg.remoteStatus, reg.remoteStatusDate || null, reg.onHoldStatusReason || null, extrasPayload);
            if (!response?.data?.success) {
                toast.error('Network status update failed');
                return;
            }
            const inviteOutcome = (response?.data?.results || {}) as IDonorShieldInviteOutcome;
            const donorShieldInviteSucceeded = !!inviteOutcome.inviteSent;
            const preOpNoticeSent = !!inviteOutcome.preOpScheduledNoticeSent;
            const refreshed = await this.refreshRegistrationAfterStatusUpdate(reg.id);
            if (!refreshed) {
                toast.error('Saved, but unable to refresh donor details.');
                return;
            }
            this.setState(prev => ({
                drawerAdvancedReimbursementWorkupModalOpen: false,
                drawerAdvancedReimbursementEnrolledScheduleModalOpen: false,
                drawerArDeclinedNetworkSnapshot: inviteFlowApplicable ? null : prev.drawerArDeclinedNetworkSnapshot,
                donorShieldInviteSent: donorShieldInviteSucceeded
                    ? { show: true, donorName: refreshed.fullName || '' }
                    : prev.donorShieldInviteSent
            }));
            if (shouldWarnDonorShieldInviteNotSent(inviteOutcome, preOpNoticeSent)) {
                toast.warn(donorShieldInviteNotSentMessage(inviteOutcome));
            } else if (!donorShieldInviteSucceeded) {
                if (
                    isEnrolledInAdvancedReimbursement(reg)
                    && isPreOpScheduledWithFutureDate(reg)
                ) {
                    if (preOpNoticeSent) {
                        toast.success('Saved. Donor notified of scheduled pre-op appointment and next Advanced Reimbursement steps.');
                    } else {
                        toast.success('Saved. Pre-op appointment date confirmed.');
                    }
                } else if (
                    isEnrolledInAdvancedReimbursement(reg)
                    && isWorkupScheduledWithFutureDate(reg)
                ) {
                    toast.success('Saved. Workup appointment date confirmed.');
                } else {
                    toast.success('Saved');
                }
            }
        } catch {
            toast.error('Save failed');
        } finally {
            hideLoading();
        }
    };

    handleDrawerAdvancedReimbursementWorkupModalClose = () => {
        this.setState({ drawerAdvancedReimbursementWorkupModalOpen: false });
    };

    mapDrawerArSearchHits = (results: any[]) => {
        return (results || []).map((x: any) => ({
            id: x.id,
            donorAlias: x.donorAlias,
            recipientAlias: x.recipientAlias,
            donorEmail: x.donorEmail,
            donorName: x.donorName,
            donorBirthDate: x.donorBirthDate,
            recipientFirstName: x.recipientFirstName,
            recipientLastName: x.recipientLastName,
            recipientBirthDate: x.recipientBirthDate,
            surgeryDate: x.surgeryDate,
            watrRequestId: x.watrRequestId,
            donorRegistrationId: x.donorRegistrationId
        }));
    };

    /** Liver AR: DonorShield Direct records only (OrganType.Liver). */
    handleDrawerArDsdPersonSearch = async (firstName: string, lastName: string, birthDate: string) => {
        const response = await this.props.searchArPerson(
            this.props.centerId,
            firstName,
            lastName,
            birthDate,
            DashDonationType.Liver
        );
        if (!response?.data?.success) {
            return [];
        }
        return this.mapDrawerArSearchHits(response.data.results || []);
    };

    /** Kidney AR: Donor table records only (not DSD). */
    handleDrawerArDonorPersonSearch = async (firstName: string, lastName: string, birthDate: string) => {
        const response = await this.props.searchArDonorPerson(
            this.props.centerId,
            firstName,
            lastName,
            birthDate
        );
        if (!response?.data?.success) {
            return [];
        }
        return this.mapDrawerArSearchHits(response.data.results || []);
    };

    /** Liver AR only: DSD alias lookup. */
    handleDrawerArAliasSearch = async (donorAlias: string, recipientAlias?: string) => {
        const response = await this.props.searchArAliases(
            this.props.centerId,
            donorAlias || '',
            recipientAlias || '',
            DashDonationType.Liver
        );
        if (!response?.data?.success) {
            return [];
        }
        return this.mapDrawerArSearchHits(response.data.results || []);
    };

    handleDrawerAdvancedReimbursementEnrolledScheduleModalClose = () => {
        this.setState({ drawerAdvancedReimbursementEnrolledScheduleModalOpen: false });
    };

    handleDrawerAdvancedReimbursementEnrolledScheduleConfirm = () => {
        this.setState({ drawerAdvancedReimbursementEnrolledScheduleModalOpen: false }, () => {
            void this.executeDrawerSaveNetworkCardWithExtras();
        });
    };

    handleDrawerAdvancedReimbursementSaveWorkupOnly = () => {
        const reg = this.state.view.data;
        if (!reg) {
            return;
        }
        this.setState({
            drawerAdvancedReimbursementWorkupModalOpen: false,
            drawerArDeclinedNetworkSnapshot: advancedReimbursementNetworkPromptSnapshot(reg)
        }, () => void this.executeDrawerSaveNetworkCardWithExtras('no', null));
    };

    handleDrawerAdvancedReimbursementSubmitApply = (form: IAdvancedReimbursementSubmittedForm) => {
        const regSnapshot = this.state.view.data;
        if (!regSnapshot) {
            return;
        }
        const regId = regSnapshot.id;
        this.setState(prev => {
            const patchReg = (r: IDonorRegistration): IDonorRegistration => ({
                ...r,
                donorShieldInvitePendingWorkup: true,
                ...(form.ddRecipFirstName != null ? { recipFirstName: form.ddRecipFirstName } : {}),
                ...(form.ddRecipLastName != null ? { recipLastName: form.ddRecipLastName } : {}),
                ...(form.ddRecipDob != null ? { recipDob: form.ddRecipDob } : {})
            });
            const nextList = prev.list.map(item => item.id === regId ? patchReg(item) : item);
            const nextViewRow = patchReg(prev.view.data);
            return {
                list: nextList,
                view: { ...prev.view, data: nextViewRow },
                drawerAdvancedReimbursementWorkupModalOpen: false,
                drawerArDeclinedNetworkSnapshot: null
            };
        }, () => void this.executeDrawerSaveNetworkCardWithExtras('yes', form));
    };

    handleDetailsChange = (field: string, value: any) => {
        this.setState(prev => {
            const id = prev.view.data.id;

            const updatedViewData = { ...prev.view.data, [field]: value };

            const updatedList = prev.list.map(
                item => item.id === id ? { ...item, [field]: value } : item
            );

            return {
                list: updatedList,
                view: { ...prev.view, data: updatedViewData }
            };
        });
    }

    handleAssignedCoordinatorChange = (regId: number, contactId: number) => {
        let data = this.state.list.find(x => x.id == regId);

        if (contactId > 0) {
            this.props.showLoading('Changing assigned coordinator, one moment please...').then(() => {
                this.props.changeAssignedCoordinator(this.props.centerId, regId, contactId).then(async response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        let logResponse = await this.props.getDonorCenterLogEntries(this.props.centerId, regId, this.props.isAdminSection);
                        let reg = this.state.list.find(x => x.id == regId);
                        let contact = this.state.coordinatorListForCenter.find(x => x.contactId == contactId);

                        let coordinatorListForCenter = _.cloneDeep(this.state.coordinatorListForCenter);

                        for (let i = 0; i < coordinatorListForCenter.length; i++) {
                            coordinatorListForCenter.map(co => {
                                if (co.contactId == contactId) {
                                    co.activeCaseCount++;
                                    co.totalCaseCount++;
                                } else if (co.contactId == reg.coordinatorId) {
                                    co.activeCaseCount--;
                                    co.totalCaseCount--;
                                }

                                return co;
                            });
                        }

                        let list = _.cloneDeep(this.state.list).map(item => {
                            if (item.id == regId) {
                                item.coordinatorId = contactId;
                                item.coordinator = { id: contact.contactId, fullName: contact.fullName };
                                item.logs = logResponse.data.results;
                            }

                            return item;
                        });

                        if (this.state.view.show) {
                            data = list.find(x => x.id == this.state.view.data.id);
                        }

                        this.setState({
                            list,
                            coordinatorListForCenter,
                            view: { ...this.state.view, data }
                        }, () => {
                            toast.success('Assigned coordinator changed successfully');
                        });
                    }
                });
            });
        } else {
            this.props.showLoading('Unassigning coordinator, one moment please...').then(() => {
                this.props.unassignCoordinator(this.props.centerId, regId).then(async response => {
                    this.props.hideLoading();

                    if (response.data.success) {
                        let logResponse = await this.props.getDonorCenterLogEntries(this.props.centerId, regId, this.props.isAdminSection);

                        let list = _.cloneDeep(this.state.list).map(item => {
                            if (item.id == regId) {
                                item.coordinatorId = 0;
                                item.coordinator = null;
                                item.logs = logResponse.data.results;
                            }

                            return item;
                        });

                        if (this.state.view.show) {
                            data = list.find(x => x.id == this.state.view.data.id);
                        }

                        this.setState({
                            list,
                            view: { ...this.state.view, data }
                        }, () => {
                            toast.success('Coordinator unassigned successfully');
                        });
                    }
                });
            });
        }
    }

    handleViewRegistration = (id: number) => {
        this.props.showLoading('Getting registration information, one moment please...').then(() => {
            this.props.getDonorCenterLogEntries(this.props.centerId, id, this.props.isAdminSection)
                .then(response => {
                    if (response.data.success) {
                        let data = _.cloneDeep(this.state.list).find(x => x.id == id);

                        data.logs = response.data.results;

                        this.setState({
                            view: {
                                show: true,
                                data
                            },
                            viewPersistedCoordinatorId: Number(data.coordinatorId ?? 0)
                        }, () => {
                            let search = _.cloneDeep(this.state.search);
                            search.id = id;

                            this.setUrlParameters(search, false);
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleDiagnosticsView = (id: number) => {
        this.props.showLoading('Getting registration Information, one moment please...').then(() => {
            this.props.getDonorCenterLogEntries(this.props.centerId, id, this.props.isAdminSection).then(async response => {
                if (response.data.success) {
                    let data = _.cloneDeep(this.state.list).find(x => x.id == id);

                    data.logs = response.data.results;

                    this.setState({
                        view: {
                            show: true,
                            data
                        },
                        viewPersistedCoordinatorId: Number(data.coordinatorId ?? 0)
                    });
                }
            }).finally(() => {
                this.props.hideLoading();
            });
        });
    }

    handleSaveLogEntry = (dashRegistrationId: number, actionTaken: number, comments: string) => {
        let message = 'Adding log entry, one moment please...';

        this.props.showLoading(message).then(() => {
            this.props.saveLogEntry(this.props.centerId, dashRegistrationId, actionTaken, comments)
                .then(response => {
                    let list = _.cloneDeep(this.state.list).map(item => {
                        if (item.id == dashRegistrationId) {
                            return response.data.results;
                        }

                        return item;
                    });

                    let data = list.find(x => x.id == dashRegistrationId);

                    this.setState({
                        list,
                        view: { show: true, data }
                    }, () => {
                        toast.success('Log entry added successfully');
                    });
                })
                .catch((error: AxiosError) => {
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleUpdateLogEntry = (id: number, dashRegistrationId: number, actionTaken: number, comments: string) => {
        let message = 'Updating log entry, one moment please...';

        this.props.showLoading(message).then(() => {
            this.props.updateLogEntry(id, this.props.centerId, dashRegistrationId, actionTaken, comments)
                .then(response => {
                    let list = _.cloneDeep(this.state.list).map(item => {
                        if (item.id == dashRegistrationId) {
                            return response.data.results;
                        }

                        return item;
                    });

                    let data = list.find(x => x.id == dashRegistrationId);

                    this.setState({
                        list,
                        view: { show: true, data }
                    }, () => {
                        toast.success('Log entry updated successfully');
                    });
                })
                .catch((error: AxiosError) => {
                })
                .finally(() => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    // handleCoordinatorFilterChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
    //     this.setState({
    //         filteredCoordinatorId: parseInt(e.currentTarget.value)
    //     });
    // }

    // handleShowAdvancedSearchChange = (showAdvancedSearch: boolean) => {
    //     let filters = this.getDefaultFilters(showAdvancedSearch);

    //     let search = {
    //         id: 0,
    //         showAdvancedSearch,
    //         filters
    //     }

    //     this.setState({
    //         search
    //         // showAdvancedSearch,
    //         // filters,
    //         // gridHeight: showAdvancedSearch ? '45vh' : this.state.showFilter ? '60vh' : '75vh'
    //     });
    // }

    // handleShowFilterChange = (showFilter: boolean) => {
    //     this.setState({
    //         showFilter,
    //         gridHeight: showFilter ? this.state.showAdvancedSearch ? '45vh' : '60vh' : '75vh'
    //     });
    // }

    handleUpdateSearch = (search: ISearch, refresh: boolean) => {
        this.setState({
            search
        }, () => {
            if (refresh) {
                this.handleSearch();
            }
        });
    }

    handleSearch = () => {
        let { id, filters } = this.state.search;

        let {
            firstName, lastName, email, alias, includeNkr, includeDash, includeMiSite, filterStartDate, filterEndDate, disposition,
            dateSearchType, dateOfBirth, showFilter, centerStatus, isInEmr, coordinatorId, organType, followUpDays, centerId,
            isLostInPwl, stopCommunication, connectToDonorIsDesired, referralStatus, livingDonorPrioritization, referred, donated, includeAllMs,
            excludeTransferredAndDuplicate
        } = filters;

        let updatedDob = moment(dateOfBirth);

        let filterRequest = {
            id,
            centerId,
            firstName,
            lastName,
            email,
            alias,
            includeNkr, includeDash, includeMiSite,
            filterStartDate, filterEndDate,
            showFilter, centerStatus, isInEmr,
            disposition, dateSearchType,
            dateOfBirth: updatedDob.isValid() ? updatedDob.format('YYYY-MM-DD') : '',
            coordinatorId,
            organType,
            followUpDays,
            isLostInPwl,
            stopCommunication,
            connectToDonorIsDesired,
            referralStatus,
            livingDonorPrioritization,
            referred,
            donated,
            includeAllMs,
            excludeTransferredAndDuplicate
        };

        this.setState({ fetching: true });

        this.props.showLoading("Searching, one moment please...").then(() => {
            this.getAllRegistrationsList(filterRequest)
                .then(response => {
                    if (response.data.success) {
                        let results = response.data.results;

                        this.setState({
                            list: results,
                        }, () => {
                            this.setUrlParameters(this.state.search, false);
                        });
                    }
                })
                .finally(() => {
                    this.setState({ fetching: false });
                    this.props.hideLoading();
                });
        });
    }

    handleExport = () => {
        let {
            firstName, lastName, email, alias, includeNkr, includeDash, includeMiSite, filterStartDate, filterEndDate, disposition,
            dateSearchType, dateOfBirth, showFilter, centerStatus, isInEmr, coordinatorId, organType, followUpDays,
            centerId, isLostInPwl, stopCommunication, connectToDonorIsDesired, referralStatus, micrositeRecipientId
        } = this.state.search.filters;

        let filterRequest: IDonorSearchRequest = {
            centerId,
            firstName,
            lastName,
            email,
            alias,
            includeNkr, includeDash, includeMiSite,
            filterStartDate, filterEndDate,
            disposition, dateSearchType,
            dateOfBirth, showFilter, centerStatus, isInEmr,
            coordinatorId,
            organType,
            followUpDays,
            isLostInPwl,
            stopCommunication,
            connectToDonorIsDesired,
            referralStatus,
            livingDonorPrioritization: false,
            donated: false,
            referred: false,
            includeAllMs: false,
            excludeTransferredAndDuplicate: false,
            micrositeRecipientId
        };

        this.props.showLoading("Exporting CSV file, one moment please...").then(() => {
            this.props.getAllDonorRegistrationListExport(filterRequest).then((response: any) => {
                downloadFile(response.data, `Donor-All-Filter-List.csv`, 'text/csv');
                this.props.hideLoading();
            });
        });
    }

    handleClearGrid = () => {
        this.setState({
            list: []
        });
    }

    handleDeleteLogEntry = (logId: number, dashRegistrationId: number) => {
        this.props.showLoading('Deleting log entry, one moment please...').then(() => {
            this.props.deleteLogEntry(this.props.centerId, dashRegistrationId, logId)
                .then(response => {
                    if (response.data.success) {
                        let list = _.cloneDeep(this.state.list).map(item => {
                            if (item.id == dashRegistrationId) {
                                return response.data.results;
                            }

                            return item;
                        });

                        let data = list.find(x => x.id == dashRegistrationId);

                        this.setState({
                            list,
                            view: { show: true, data }
                        }, () => {
                            toast.success('Log entry deleted successfully');
                        });
                    }
                })
                .catch((error: AxiosError) => {
                })
                .finally(() => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    handleCancelConfirmEmail = () => {
        this.setState({
            confirmView: {
                show: false,
                formData: null,
                jugArrivalDate: null
            }
        });
    }

    handleShowConfirmJugArrival = (id: number) => {
        let data = this.state.list.find(x => x.id == id);

        this.setState({
            confirmView: {
                show: true,
                formData: data,
                jugArrivalDate: moment().format("YYYY-MM-DD")
            }
        });
    }

    handleShowExpertSystemEnrollment = (id: number) => {
        let data = this.state.list.find(x => x.id == id);

        this.props.showLoading('Checking donor profile...').then(() => {
            this.props.checkDonorProfile(data.id)
                .then(response => {
                    const existingDonorAlias = response.data.success && response.data.results.exists
                        ? response.data.results.alias
                        : null;

                    this.setState({
                        confirmExpertSystemEnrollment: {
                            show: true,
                            formData: data,
                            error: '',
                            existingDonorAlias
                        }
                    });
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleShowTransferDonor = (centerId: number, id: number) => {
        let data = this.state.list.find(x => x.id == id);

        this.props.showLoading('Getting Recipient Coordinator list, one moment please...').then(() => {
            this.props.getRecipientCenterCoordList(centerId)
                .then(response => {
                    if (response.data.success) {

                        let { recipientCenterCoordinatorList } = response.data.results;

                        this.setState({
                            confirmTransferDonor: {
                                show: true,
                                formData: data,
                                coordinatorList: recipientCenterCoordinatorList,
                                coordinatorId: data.recipientCoordinatorId
                            }
                        });
                    }
                })
                .catch((error: AxiosError) => {
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleChangeCoordinator = (id: number) => {
        let updatedConfirmTransferDonor = {
            ...this.state.confirmTransferDonor,
            coordinatorId: id
        };

        this.setState({
            confirmTransferDonor: updatedConfirmTransferDonor
        }, () => {
            let { validation } = this.validateRecipientCenterConfirm();

            this.setState({
                validation
            });
        });
    };

    handleProceedTransferDonor = (id: number) => {
        let data = this.state.list.find(x => x.id == id);
        let coordinatorId = this.state.confirmTransferDonor.coordinatorId;
        let { validation } = this.validateRecipientCenterConfirm();

        this.setState({
            validation
        }, () => {
            let isValid = this.state.validation.coordinatorIdValid;

            if (isValid) {
                this.setState({
                    confirmTransferDonor: {
                        show: false,
                        formData: null,
                        coordinatorList: null,
                        coordinatorId: -1
                    }
                }, () => {
                    let { centerId, id: donorId, dashDomain, donorEditKey } = data;

                    this.props.showLoading('Redirecting to selecting a center, one moment please...').then(() => {
                        this.props.updateRecipientCenterCoord(centerId, id, coordinatorId)
                            .then(response => {
                                if (response.data.success) {
                                    window.location.href = `${dashDomain}/register/transfer-donor/${donorId}/${donorEditKey}`;
                                }
                            })
                            .finally(() => {
                                this.props.hideLoading();
                            });
                    });
                });
            }
        });
    }

    handleCancelShowTransferDonor = () => {
        this.setState({
            confirmTransferDonor: {
                show: false,
                formData: null,
                coordinatorList: null,
                coordinatorId: -1
            }
        });
    }

    handleConfirmRuleOut = (id: number) => {
        let data = this.state.list.find(x => x.id == id);

        this.setState({
            ruleOut: {
                show: true,
                data
            }
        });
    }

    handleRuleOutFromView = (donorId: number, reasonId: number, allowReRegistration: boolean, useNkrAssistance: boolean, coordinatorName?: string, phoneNumber?: string, medicalReasonCategory?: number, medicalReasonNotes?: string) => {
        if (reasonId < 1 || reasonId > 3) {
            toast.error('Invalid rule-out reason selected');
            return;
        }

        const ruleOutData = {
            ruleOutReasonId: reasonId.toString(), // Pass the actual modal reason ID (1, 2, or 3)
            allowReRegistration: allowReRegistration,
            useNkrAssistance: useNkrAssistance,
            coordinatorName: coordinatorName || '',
            phoneNumber: phoneNumber || '',
            medicalReasonCategory: medicalReasonCategory,
            medicalReasonNotes: medicalReasonNotes
        };

        this.props.showLoading('Updating record, one moment please...').then(() => {
            const request: IDashWorkFlowStatusRequest = {
                centerId: this.props.centerId,
                registrationId: donorId,
                statusId: -1, // Pass -1 to indicate this is a rule-out operation
                centerNextFollowUpDate: null,
                reviewComments: null,
                remoteStatus: null,
                onHoldStatusReason: null,
                remoteStatusDate: null,
                ruleOutReasonId: ruleOutData.ruleOutReasonId,
                allowReRegistration: ruleOutData.allowReRegistration,
                useNkrAssistance: ruleOutData.useNkrAssistance,
                coordinatorName: ruleOutData.coordinatorName,
                phoneNumber: ruleOutData.phoneNumber,
                medicalReasonCategory: ruleOutData.medicalReasonCategory,
                medicalReasonNotes: ruleOutData.medicalReasonNotes
            };

            this.props.changeStatus(request)
                .then(response => {
                    if (response.data.success) {
                        return this.props.getDonorDetails(this.props.centerId, donorId);
                    } else {
                        throw new Error('Failed to update status');
                    }
                })
                .then(donorResponse => {
                    if (donorResponse.data.success) {
                        let list = this.state.list.map(x => {
                            if (x.id == donorId) {
                                return donorResponse.data.results;
                            }
                            return x;
                        });

                        let data = list.find(x => x.id == donorId);

                        this.setState({
                            list,
                            view: {
                                show: true,
                                data
                            },
                            ruleOut: {
                                show: false,
                                data: null
                            }
                        }, () => {
                            toast.success('Rule out successful.');
                        });
                    } else {
                        toast.error('Unable to rule out the donor');

                        this.setState({
                            ruleOut: {
                                show: false,
                                data: null
                            }
                        });
                    }
                })
                .catch((error) => {
                    console.error('Rule out error:', error);
                    toast.error('Unable to rule out the donor');
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleCancelRuleOut = () => {
        this.setState({
            ruleOut: {
                show: false,
                data: null
            }
        });
    }

    handleConfirmReverseRuleOut = (id: number) => {
        let data = this.state.list.find(x => x.id == id)

        this.setState({
            reverseRuleOut: {
                show: true,
                data
            }
        });
    }

    handleSubmitReverseRuleOut = () => {
        let id = this.state.reverseRuleOut.data.id;
        let data = this.state.list.find(x => x.id == id);

        this.setState({
            reverseRuleOut: {
                show: false,
                data: undefined
            }
        }, () => {
            this.props.showLoading('Updating record, one moment please...').then(() => {
                this.props.reverseRuleOut(data.id)
                    .then(response => {
                        if (response.data.success) {
                            let list = this.state.list.map(x => {
                                if (x.id == id) {
                                    return response.data.results;
                                }

                                return x;
                            })

                            let data = list.find(x => x.id == id);

                            this.setState({
                                list,
                                view: {
                                    show: true,
                                    data
                                }
                            }, () => {
                                toast.success('Reverse rule out successful.');
                            });
                        } else {
                            toast.error('Unable to reverse the rule-out of the donor');
                        }
                    })
                    .catch(() => {

                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
            });
        });
    }

    handleCancelReverseRuleOut = () => {
        this.setState({
            reverseRuleOut: {
                show: false,
                data: null
            }
        });
    }

    sendConfirmationEmail = () => {
        this.setState({
            confirmView: {
                show: true,
                formData: null,
                jugArrivalDate: moment().format("YYYY-MM-DD")
            }
        });
    }

    handleConfirmJugArrival = () => {
        let message = 'Updating Jug Information, one moment please...';

        this.props.showLoading(message).then(() => {
            let donorReg = this.state.confirmView.formData;
            let arrivalDate = this.state.confirmView.jugArrivalDate;

            this.props.markJugAsArrived(donorReg.id, arrivalDate)
                .then(response => {
                    this.setState({
                        confirmView: {
                            show: false,
                            formData: null,
                            jugArrivalDate: moment().format("YYYY-MM-DD")
                        }
                    });

                    toast.success('Jug marked as arrived. Email sent successfully.');
                })
                .catch((error: AxiosError) => {
                    toast.error("Unable to complete request: " + error.response.data);
                })
                .finally(() => {
                    this.props.hideLoading();
                });
            ;
        });
    }

    handleSaveDetails = () => {
        let { validation, messages } = this.validate();

        this.setState({
            validation,
            messages
        }, () => {
            let {
                id,
                centerId,
                disposition,
                dispositionId,
                reviewComments,
                firstName,
                lastName,
                birthDate,
                phoneNumber,
                email,
                addressLine1,
                donorCity,
                donorState,
                donorStateId,
                donorPostalCode
            } = this.state.view.data;

            let data: IDonorDetailsRequest = {
                id,
                disposition,
                dispositionId,
                comments: reviewComments,
                firstName,
                lastName,
                birthDate,
                phoneNumber,
                email,
                addressLine1,
                donorCity,
                donorState,
                donorStateId,
                donorPostalCode,
                closeLoopSurgeryDateTime: '',
                closeLoopEntityTypeId: 0,
                closeLoopEntityType: 0
            };

            let isValid = this.state.validation.birthDate;

            if (isValid) {
                this.props.showLoading('Saving Donor Details data, one moment please...').then(() => {
                    this.props.updateDonorDetails(centerId, data).then(response => {
                        this.props.hideLoading();
                        if (response.data.success) {
                            this.refreshData();
                            toast.success('General data updated successfully');
                        }
                    });
                });
            }
        });
    }

    handleSaveDisposition = () => {
        let {
            id,
            centerId,
            disposition,
            dispositionId,
            closeLoopSurgeryDateTime,
            closeLoopEntityTypeId
        } = this.state.view.data;

        let data: IDonorDetailsRequest = {
            id,
            disposition,
            dispositionId,
            comments: '',
            closeLoopSurgeryDateTime,
            closeLoopEntityTypeId,
            closeLoopEntityType: 5,
            firstName: '',
            lastName: '',
            birthDate: '',
            phoneNumber: '',
            email: '',
            addressLine1: '',
            donorCity: '',
            donorState: '',
            donorStateId: 0,
            donorPostalCode: ''
        };

        this.props.showLoading('Saving Disposition data, one moment please...').then(() => {
            this.props.updateDisposition(centerId, data).then(response => {
                this.props.hideLoading();
                if (response.data.success) {
                    toast.success('General data updated successfully');
                }
            });
        });
    }

    handleSaveComments = () => {
        let {
            id,
            centerId,
            reviewComments,
        } = this.state.view.data;

        let data: IDonorDetailsRequest = {
            id,
            disposition: '',
            dispositionId: 0,
            comments: reviewComments,
            closeLoopSurgeryDateTime: '',
            closeLoopEntityTypeId: 0,
            closeLoopEntityType: 0,
            firstName: '',
            lastName: '',
            birthDate: '',
            phoneNumber: '',
            email: '',
            addressLine1: '',
            donorCity: '',
            donorState: '',
            donorStateId: 0,
            donorPostalCode: ''
        };

        this.props.showLoading('Saving Comments data, one moment please...').then(() => {
            this.props.updateComments(centerId, data).then(response => {
                this.props.hideLoading();
                if (response.data.success) {
                    toast.success('General data updated successfully');
                }
            });
        });
    }

    handleConfirmEmail = (id: number) => {
        let data = this.state.list.find(x => x.id == id);

        this.setState({
            confirmView: {
                show: true,
                formData: data,
                jugArrivalDate: moment().format("YYYY-MM-DD")
            }
        });
    }

    handleMentorConfirm = (id: number) => {
        let data = this.state.list.find(x => x.id == id);

        this.setState({
            mentorConfirmView: {
                show: true,
                data
            }
        });
    }

    handleCancelMentorConfirm = () => {
        this.setState({
            mentorConfirmView: {
                show: false,
                data: null
            }
        });
    }

    handleArrivalDateChange = (arrivalDate: string) => {
        let confirmView = _.cloneDeep(this.state.confirmView);
        confirmView.jugArrivalDate = arrivalDate;

        this.setState({
            confirmView
        });
    }

    handleUploadLabResults = (file: File) => {
        let id = this.state.uploadLabResults.data.id;

        this.setState({
            uploadLabResults: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Uploading lab results, one moment please...').then(() => {
                this.props.uploadLabs(id, file)
                    .then(response => {
                        if (response.data.success) {
                            let list = _.cloneDeep(this.state.list).map(x => {
                                if (x.id == id) {
                                    return response.data.results;
                                }

                                return x;
                            });

                            this.setState({
                                list
                            }, () => {
                                toast.success('Lab results uploaded successfully.');
                            });
                        }
                    })
                    .catch((error: AxiosError) => {
                        toast.error("Unable to complete request: " + error.response.data);
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
                ;
            });
        });
    };

    handleShowUploadLabResults = (id: number) => {
        let data = this.state.list.find(x => x.id == id);

        this.setState({
            uploadLabResults: {
                show: true,
                data
            }
        });
    }

    handleCancelUploadLabResults = () => {
        this.setState({
            uploadLabResults: {
                show: false,
                data: null
            }
        });
    }

    handleConfirmConvertToDirectToCenter = () => {
        let { id, centerId } = this.state.convertToDirectCenter.data;

        this.props.showLoading('Changing status, one moment please...').then(() => {
            this.props.convertToDirectToCenter(id, centerId)
                .then(response => {
                    if (response.data.success) {
                        this.handleCancelConfirmConvertToDirectToCenter();
                        toast.success('Status changed successfully.');
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error("Unable to complete request: " + error.response.data);
                })
                .finally(() => {
                    this.props.hideLoading();
                });
            ;
        });
    };

    handleShowConfirmConvertToDirectToCenter = (id: number) => {
        let data = this.state.list.find(x => x.id == id);
        this.setState({
            convertToDirectCenter: {
                show: true,
                data
            }
        });
    }

    handleCancelConfirmConvertToDirectToCenter = () => {
        this.setState({
            convertToDirectCenter: {
                show: false,
                data: null
            }
        });
    }

    handleConfirmRestartPwl = () => {
        let { id } = this.state.restartPwl.data;
        let isCystatinC = this.state.restartPwl.isCystatinC;

        this.props.showLoading('Changing status, one moment please...').then(() => {
            this.props.restartPwl(id, isCystatinC)
                .then(response => {
                    if (response.data.success) {
                        this.handleCancelConfirmRestartPwl()
                        toast.success('Status changed successfully.');
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error(
                        <>
                            {error.response.data.split("\n").map((line, i) => (
                                <div key={i}>{line}</div>
                            ))}
                        </>
                    );
                })
                .finally(() => {
                    this.props.hideLoading();
                });
            ;
        });
    };

    handleShowConfirmRestartPwl = (id: number, isCystatinC: boolean) => {
        let data = this.state.list.find(x => x.id == id);

        this.setState({
            restartPwl: {
                show: true,
                data,
                isCystatinC
            }
        });
    }

    handleCancelConfirmRestartPwl = () => {
        this.setState({
            restartPwl: {
                show: false,
                data: null,
                isCystatinC: false
            }
        });
    }

    handleShowConfirmIntendedMicrositeModal = (data: IDonorRegistration) => {
        this.setState({
            intendedMicrositeRecipient: {
                show: true,
                donorData: data
            }
        });
    }

    handleCancelConfirmIntendedMicrositeModal = (data: IDonorRegistration) => {
        this.setState({
            intendedMicrositeRecipient: {
                show: false,
                donorData: null
            }
        });
    }

    handleConfirmIntendedMicrositeRecipient = (micrositeRecipientId: number) => {
        // call your action here once the endpoint exists
        let data: IMicrositeConvertDonationType = {
            centerId: this.props.centerId,
            donorId: null,
            recipientId: null,
            donorRegistrationId: this.state.intendedMicrositeRecipient.donorData.id,
            micrositeRecipientId: micrositeRecipientId,
            donationType: DonationType.StandardVoucher,
            conversionType: ConversionType.IntendedMicrositeRecipient,
            donationDate: moment().format('YYYY-MM-DD')
        };

        this.props.showLoading('Converting donation type, please wait...').then(() => {
            this.props.convertDonor(data)
                .then(response => {
                    if (response.data.success) {
                        toast.success('Donation type successfully updated...');
                        this.setState({
                            intendedMicrositeRecipient: {
                                show: false,
                                donorData: null
                            }
                        }, () => {
                            this.getData(true);
                        });
                    } else {
                        toast.error(response.data.message, { autoClose: false });
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error('Donation type was unable to be converted...', { autoClose: false });
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleCancelIntendedMicrositeRecipient = () => {
        this.setState({
            intendedMicrositeRecipient: {
                show: false,
                donorData: null
            }
        });
    }

    handleConfirmExpireDonor = () => {
        let { id, centerId } = this.state.expireDonor.data;

        this.props.showLoading('Changing status, one moment please...').then(() => {
            this.props.expireDonor(id, centerId)
                .then(response => {
                    if (response.data.success) {
                        this.handleCancelConfirmExpireDonor();
                        toast.success('Status changed successfully.');
                    }
                })
                .catch((error: AxiosError) => {
                    toast.error("Unable to complete request: " + error.response.data);
                })
                .finally(() => {
                    this.props.hideLoading();
                });
            ;
        });
    };

    handleShowConfirmExpireDonor = (id: number) => {
        let data = this.state.list.find(x => x.id == id);

        this.setState({
            expireDonor: {
                show: true,
                data
            }
        });
    }

    handleCancelConfirmExpireDonor = () => {
        this.setState({
            expireDonor: {
                show: false,
                data: null
            }
        });
    }

    handleConfirmOptOutDonor = () => {
        let { id, centerId } = this.state.optOutDonor.data;

        this.setState({
            optOutDonor: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Changing status, one moment please...').then(() => {
                this.props.optOutDonor(id, centerId)
                    .then(response => {
                        if (response.data.success) {
                            let list = this.state.list.map(x => {
                                if (x.id == id) {
                                    return response.data.results;
                                }

                                return x;
                            });

                            let data = list.find(x => x.id == id);

                            this.setState({
                                list,
                                view: {
                                    show: true,
                                    data
                                }
                            }, () => {
                                toast.success('Status changed successfully.');
                            });
                        }
                    })
                    .catch((error: AxiosError) => {
                        toast.error("Unable to complete request: " + error.response.data);
                    })
                    .finally(() => {
                        this.props.hideLoading();
                    });
                ;
            });
        });
    };

    handleShowConfirmOptOutDonor = (id: number) => {
        let data = this.state.list.find(x => x.id == id);

        this.setState({
            optOutDonor: {
                show: true,
                data
            }
        });
    }

    handleCancelConfirmOptOutDonor = () => {
        this.setState({
            optOutDonor: {
                show: false,
                data: null
            }
        });
    }

    handleProcessExpertSystemEnrollment = (useBulkKit: number, alias: string, medicalRecordId: number) => {
        let registrationId = this.state.confirmExpertSystemEnrollment.formData.id;

        this.props.showLoading('Enrolling Donor in Expert System, one moment please...').then(() => {
            this.props.enrollExpertSystem(registrationId, useBulkKit, alias, medicalRecordId)
                .then(response => {
                    if (response.data.success) {
                        let list = _.cloneDeep(this.state.list).map(x => {
                            if (x.id == registrationId) {
                                x.isInExpertSystem = true;
                                x.isLinkedToDonor = true;
                            }

                            return x;
                        });

                        let donorRegistration = list.find(x => x.id == registrationId);

                        let { donorId, existingTyping, existingRequestForTyping, existingSwabMessage } = response.data.results;

                        this.setState({
                            list,
                            // donorRegistration,
                            confirmExpertSystemEnrollment: {
                                show: false,
                                formData: null,
                                error: '',
                                existingDonorAlias: null
                            },
                            confirmExpertSystemResponse: {
                                show: true,
                                donorId,
                                useBulkKit,
                                existingTyping,
                                existingRequestForTyping,
                                existingSwabMessage,
                                alias
                            }
                        });
                    } else {
                        let confirmExpertSystemEnrollment = _.cloneDeep(this.state.confirmExpertSystemEnrollment);
                        confirmExpertSystemEnrollment.error = response.data.message;

                        this.setState({
                            confirmExpertSystemEnrollment
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleCancelExpertSystemEnrollment = () => {
        this.setState({
            confirmExpertSystemEnrollment: {
                show: false,
                formData: null,
                error: '',
                existingDonorAlias: null
            }
        });
    }

    handleCancelExpertSystemResponse = () => {
        this.setState({
            confirmExpertSystemResponse: {
                show: false,
                donorId: -1,
                useBulkKit: null,
                existingTyping: false,
                existingRequestForTyping: false,
                alias: ''
            }
        });
    }

    handleSendPediatricGalleryEmail = (data: IDonorRegistration) => {
        if (!window.confirm('Send the Pediatric Gallery email to this donor?')) {
            return;
        }

        this.props.showLoading('Sending Email, one moment please...').then(() => {
            this.props.sendPediatricGalleryEmail(this.props.centerId, data.id)
                .then(() => {
                    toast.success('Email sent successfully');
                })
                .catch((error: AxiosError) => {
                    toast.error("Unable to complete request: " + error.response.data);
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleGetLabResults = (id: number) => {
        this.props.showLoading('Getting lab results, one moment please...').then(() => {
            this.props.getLabResultsNotCombined(id)
                .then(response => {
                    downloadFile(response.data, 'lab-results.pdf', 'application/pdf');
                })
                .catch(() => {
                    toast.error('We are unable to get the lab results file.');
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    handleGetLabResultsCombined = (id: number) => {
        this.props.showLoading('Getting lab results, one moment please...').then(() => {
            this.props.getLabResultsCombined(id)
                .then(response => {
                    downloadFile(response.data, 'lab-results-combined.pdf', 'application/pdf');
                })
                .catch(() => {
                    toast.error('We are unable to get the lab results file.');
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        })
    }

    handleGetLabOrders = (id: number) => {
        this.props.showLoading('Getting lab Orders, one moment please...').then(() => {
            this.props.getLabOrder(id)
                .then(response => {
                    downloadFile(response.data, 'lab-order.pdf', 'application/pdf');
                })
                .catch(() => {
                    toast.error('We are unable to get the lab order file.');
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        })
    }

    render = () => {
        const showIsExpertSystemParticipant = this.props.isCenter ? this.props.app.center.isExpertSystemParticipant : true;
        const gridHeight = this.state.search.showAdvancedSearch ? '43vh' : this.props.subSection != 'TO-DO' ? '56vh' : '65vh';

        return (
            <>
                <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', marginBottom: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ display: 'flex' }}>
                            {this.state.fetching && (
                                <>
                                    <div style={{ marginRight: 5 }}>Fetching registrations...</div>
                                    <Loader size={20} color={'#a1a1a1'} />
                                </>
                            )}
                        </div>
                    </div>
                </div>

                <div ref={this.saveContainer}></div>

                <Filters
                    centerId={this.props.centerId}
                    data={this.state.search}
                    subSection={this.props.subSection}
                    isAdminSection={this.props.isAdminSection}
                    statusList={this.state.statusListForCenter}
                    dispositionList={this.state.dispositionList}
                    coordinatorList={this.state.coordinatorListForCenter}
                    referDonorToNkr={this.state.referDonorToNkr}
                    onChange={this.handleUpdateSearch}
                    onClearGrid={this.handleClearGrid}
                    onSearch={this.handleSearch}
                    onExport={this.handleExport}
                />

                {!this.props.isAdminSection &&
                    <Grid
                        data={this.state.list}
                        isSuperAdmin={this.props.isAdminSection}
                        centerId={this.props.centerId}
                        subSection={this.props.subSection}
                        gridHeight={gridHeight}
                        isExpertSystemParticipant={showIsExpertSystemParticipant}
                        statusList={this.state.statusListForCenter}
                        coordinatorList={this.state.coordinatorListForCenter}
                        onViewRegistration={this.handleViewRegistration}
                        onItemSelected={this.handleItemSelected}
                        onAssignedCoordinatorChange={this.handleAssignedCoordinatorChange}
                    />
                }

                {this.props.isAdminSection &&
                    <GridPwl
                        data={this.state.list}
                        isSuperAdmin={this.props.isAdminSection}
                        centerId={this.props.centerId}
                        subSection={this.props.subSection}
                        gridHeight={gridHeight}
                        isExpertSystemParticipant={showIsExpertSystemParticipant}
                        onItemSelected={this.handleItemSelected}
                        onAssignedCoordinatorChange={this.handleAssignedCoordinatorChange}
                    />
                }

                <div style={{ marginBottom: 5 }}>{this.state.list.length} records shown...</div>

                <Drawer
                    width="42vw"
                    placement="right"
                    getContainer={this.getContainer}
                    open={this.state.view.show}
                >
                    <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                        <div style={{ padding: 10 }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
                                <h3 style={{ margin: 0 }}>DASH Registration</h3>
                                <Button bsStyle='link' bsSize='sm' onClick={this.handleCancelView}><Glyphicon glyph='remove' /></Button>
                            </div>

                            {this.props.isAdminSection &&
                                <ViewPreWorkUp
                                    centerId={this.props.centerId}
                                    data={this.state.view.data}
                                    dataList={[]}
                                    statusList={this.state.statusListForCenter}
                                    remoteStatusList={this.state.remoteStatusList}
                                    stateList={this.state.stateList}
                                    actionList={this.state.actionList}
                                    dispositionList={this.state.dispositionList}
                                    donationTypeList={this.state.donationTypeList}
                                    validation={this.state.validation}
                                    messages={this.state.messages}
                                    onDataChange={this.handleDetailsChange}
                                    updateDataStatus={this.handlePwlStatusChange}
                                    updateDisposition={this.handleSaveDisposition}
                                    updateComments={this.handleSaveComments}
                                    onSave={this.handleSaveDetails}
                                    isMobile={false}
                                    ruleOutReasons={this.state.ruleOutReasons}
                                    onRuleOut={this.handleRuleOutFromView}
                                />
                            }

                            {this.props.isCenter &&
                                <ViewDonorRegistration
                                    centerId={this.props.centerId}
                                    data={this.state.view.data}
                                    dataList={[]}
                                    statusList={this.state.statusListForCenter}
                                    remoteStatusList={this.state.remoteStatusList}
                                    actionList={this.state.actionList}
                                    coordinatorList={this.state.coordinatorListForCenter}
                                    ruleOutReasons={this.state.ruleOutReasons}
                                    statusFormBaselineKey={this.state.statusFormBaselineKey}
                                    isMobile={false}
                                    onStatusChange={this.handleStatusChange}
                                    onDataChange={this.handleDetailsChange}
                                    onSaveCenterCard={this.handleSaveCenterCardDrawer}
                                    onSaveNetworkCard={this.handleSaveNetworkCardDrawer}
                                    onSaveLogEntry={this.handleSaveLogEntry}
                                    onUpdateLogEntry={this.handleUpdateLogEntry}
                                    onDeleteLogEntry={this.handleDeleteLogEntry}
                                    onItemSelected={this.handleItemSelected}
                                    onRuleOut={this.handleRuleOutFromView}
                                />
                            }

                        </div>
                        <div className='text-center bg-info'>
                            <Button bsStyle='link' block onClick={this.handleCancelView}>Close This View</Button>
                        </div>
                    </div>
                </Drawer>

                <MarkJugArrivedSendEmail
                    show={this.state.confirmView.show}
                    formData={this.state.confirmView.formData}
                    arrivalDate={this.state.confirmView.jugArrivalDate}
                    onDateChange={this.handleArrivalDateChange}
                    onConfirm={this.handleConfirmJugArrival}
                    onCancel={this.handleCancelConfirmEmail} />

                <RecipientCenterCoordinatorConfirm
                    show={this.state.confirmTransferDonor.show}
                    donorId={this.state.confirmTransferDonor.formData != null ? this.state.confirmTransferDonor.formData.id : 0}
                    coordinatorList={this.state.confirmTransferDonor.coordinatorList}
                    coordinatorId={this.state.confirmTransferDonor.coordinatorId}
                    validation={this.state.validation}
                    onCoordinatorChange={this.handleChangeCoordinator}
                    onConfirm={this.handleProceedTransferDonor}
                    onCancel={this.handleCancelShowTransferDonor} />

                <DonorConnectEmailConfirmation
                    container={this.getContainer()}
                    show={this.state.mentorConfirmView.show}
                    startingEmail={this.state.mentorConfirmView.data != null ? this.state.mentorConfirmView.data.email : ''}
                    onSendEmail={this.handleSendEmail}
                    onCancel={this.handleCancelMentorConfirm} />

                <UploadLabResults
                    show={this.state.uploadLabResults.show}
                    fullName={this.state.uploadLabResults.data != null ? this.state.uploadLabResults.data.firstName + ' ' + this.state.uploadLabResults.data.lastName : ''}
                    onSubmit={this.handleUploadLabResults}
                    onCancel={this.handleCancelUploadLabResults} />

                <ConvertToDirectToCenterModal
                    show={this.state.convertToDirectCenter.show}
                    fullName={this.state.convertToDirectCenter.data != null ? this.state.convertToDirectCenter.data.firstName + ' ' + this.state.convertToDirectCenter.data.lastName : ''}
                    onConfirm={this.handleConfirmConvertToDirectToCenter}
                    onCancel={this.handleCancelConfirmConvertToDirectToCenter} />

                <RestartPwlModal
                    show={this.state.restartPwl.show}
                    fullName={this.state.restartPwl.data != null ? this.state.restartPwl.data.firstName + ' ' + this.state.restartPwl.data.lastName : ''}
                    onConfirm={this.handleConfirmRestartPwl}
                    onCancel={this.handleCancelConfirmRestartPwl}
                    isCystatinC={this.state.restartPwl.isCystatinC} />

                <ExpireDonorModal
                    show={this.state.expireDonor.show}
                    fullName={this.state.expireDonor.data != null ? this.state.expireDonor.data.firstName + ' ' + this.state.expireDonor.data.lastName : ''}
                    onConfirm={this.handleConfirmExpireDonor}
                    onCancel={this.handleCancelConfirmExpireDonor} />

                <OptOutDonorModal
                    show={this.state.optOutDonor.show}
                    fullName={this.state.optOutDonor.data != null ? this.state.optOutDonor.data.firstName + ' ' + this.state.optOutDonor.data.lastName : ''}
                    onConfirm={this.handleConfirmOptOutDonor}
                    onCancel={this.handleCancelConfirmOptOutDonor} />

                <IntendedMicrositeRecipientModal
                    show={this.state.intendedMicrositeRecipient.show}
                    donorName={this.state.intendedMicrositeRecipient.donorData?.fullName || ''}
                    patientList={this.state.pedsList} // wire to your lookup data once available
                    onHide={this.handleCancelIntendedMicrositeRecipient}
                    onConfirm={this.handleConfirmIntendedMicrositeRecipient} />

                <ExpertSystemEnrollmentConfirm
                    show={this.state.confirmExpertSystemEnrollment.show}
                    centerId={this.props.centerId}
                    data={this.state.confirmExpertSystemEnrollment.formData}
                    error={this.state.confirmExpertSystemEnrollment.error}
                    existingDonorAlias={this.state.confirmExpertSystemEnrollment.existingDonorAlias}
                    onConfirm={this.handleProcessExpertSystemEnrollment}
                    onCancel={this.handleCancelExpertSystemEnrollment} />

                <ExpertSystemEnrollmentResponse
                    show={this.state.confirmExpertSystemResponse.show}
                    useBulkKit={this.state.confirmExpertSystemResponse.useBulkKit}
                    donorId={this.state.confirmExpertSystemResponse.donorId}
                    centerId={this.props.centerId}
                    existingTyping={this.state.confirmExpertSystemResponse.existingTyping}
                    existingRequestForTyping={this.state.confirmExpertSystemResponse.existingRequestForTyping}
                    existingSwabMessage={this.state.confirmExpertSystemResponse.existingSwabMessage}
                    alias={this.state.confirmExpertSystemResponse.alias}
                    onCancel={this.handleCancelExpertSystemResponse} />

                <RuleOutDonorModal
                    show={this.state.ruleOut.show}
                    donorName={this.state.ruleOut.data?.fullName || ''}
                    ruleOutReasons={this.state.ruleOutReasons}
                    onHide={this.handleCancelRuleOut}
                    onRuleOut={(reasonId, allowReRegistration, useNkrAssistance, coordinatorName, phoneNumber, medicalReasonCategory, medicalReasonNotes) => {
                        if (this.state.ruleOut.data) {
                            this.handleRuleOutFromView(this.state.ruleOut.data.id, reasonId, allowReRegistration, useNkrAssistance, coordinatorName, phoneNumber, medicalReasonCategory, medicalReasonNotes);
                        }
                    }} />

                <ReverseRuleOut
                    show={this.state.reverseRuleOut.show}
                    donor={this.state.reverseRuleOut.data}
                    onReverseRuleOut={this.handleSubmitReverseRuleOut}
                    onCancel={this.handleCancelReverseRuleOut} />

                {this.state.view.show && this.state.view.data != null && (
                    <AdvancedReimbursementWorkupModal
                        show={this.state.drawerAdvancedReimbursementWorkupModalOpen}
                        registration={this.state.view.data}
                        milestone={Number(this.state.view.data?.remoteStatus) === PRE_OP_SCHEDULED_REMOTE_STATUS_ID ? 'preop' : 'workup'}
                        onClose={this.handleDrawerAdvancedReimbursementWorkupModalClose}
                        onSaveWorkupWithoutInvite={this.handleDrawerAdvancedReimbursementSaveWorkupOnly}
                        onSaveWithAdvancedReimbursement={this.handleDrawerAdvancedReimbursementSubmitApply}
                        onSearchPerson={
                            Number(this.state.view.data?.donationType) === DashDonationType.Liver
                                ? this.handleDrawerArDsdPersonSearch
                                : this.handleDrawerArDonorPersonSearch
                        }
                        onSearchAliases={
                            Number(this.state.view.data?.donationType) === DashDonationType.Liver
                                ? this.handleDrawerArAliasSearch
                                : undefined
                        }
                    />
                )}

                {this.state.view.show && this.state.view.data != null && (
                    <AdvancedReimbursementEnrolledScheduleModal
                        show={this.state.drawerAdvancedReimbursementEnrolledScheduleModalOpen}
                        registration={this.state.view.data}
                        onClose={this.handleDrawerAdvancedReimbursementEnrolledScheduleModalClose}
                        onConfirm={this.handleDrawerAdvancedReimbursementEnrolledScheduleConfirm}
                    />
                )}

                <DonorShieldInviteSentModal
                    show={this.state.donorShieldInviteSent.show}
                    donorName={this.state.donorShieldInviteSent.donorName}
                    onClose={this.handleCloseDonorShieldInviteSent}
                />
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getAllDonorRegistrationList: (data, isSuperAdmin) => {
            return dispatch(DashCenterActionCreators.getDonorRegistrationAllList(data, isSuperAdmin));
        },
        getDonorRegistrationSearchIntendedList(data, isSuperAdmin) {
            return dispatch(DashCenterActionCreators.getDonorRegistrationSearchIntendedList(data, isSuperAdmin));
        },
        getLookupData: (centerId, isSuperAdmin) => {
            return dispatch(DashCenterActionCreators.getDashCenterLookupData(centerId, isSuperAdmin));
        },
        getReferralConfig: (centerId) => {
            return dispatch(CenterActionCreators.getReferralConfig(centerId));
        },
        getAllDonorRegistrationListExport: (regRequest) => {
            return dispatch(DashCenterActionCreators.getDonorRegistrationAllListExport(regRequest));
        },
        changeAssignedCoordinator: (centerId, regId, contactId) => {
            return dispatch(DashCenterActionCreators.changeAssignedCoordinator(centerId, regId, contactId));
        },
        unassignCoordinator: (centerId, regId) => {
            return dispatch(DashCenterActionCreators.unassignCoordinator(centerId, regId));
        },
        changeStatus: (request) => {
            return dispatch(DashCenterActionCreators.changeStatus(request));
        },
        updateDonorRegistrationWorkflowStatus: (centerId, regId, statusId, centerNextFollowUpDate) => {
            return dispatch(DashCenterActionCreators.updateDonorRegistrationWorkflowStatus(centerId, regId, statusId, centerNextFollowUpDate));
        },
        updateDonorRegistrationNetworkStatus: (centerId, regId, remoteStatus, remoteStatusDate, onHoldStatusReason, extras?: IAdvancedReimbursementNetworkPayload | null) => {
            return dispatch(DashCenterActionCreators.updateDonorRegistrationNetworkStatus(centerId, regId, remoteStatus, remoteStatusDate, onHoldStatusReason, extras));
        },
        searchArPerson: (centerId, firstName, lastName, birthDate, organType) => {
            return dispatch(DonorShieldDirectActionCreators.searchByPerson(centerId, firstName, lastName, birthDate, organType));
        },
        searchArAliases: (centerId, donorAlias, recipientAlias, organType) => {
            return dispatch(DonorShieldDirectActionCreators.searchByAliases(centerId, donorAlias, recipientAlias, organType));
        },
        searchArDonorPerson: (centerId, firstName, lastName, birthDate) => {
            return dispatch(DonorSearchActionCreators.searchByPerson(centerId, firstName, lastName, birthDate));
        },
        saveLogEntry: (centerId, dashRegistrationId, actionTaken, comments) => {
            return dispatch(DashCenterActionCreators.saveLogEntry(centerId, dashRegistrationId, actionTaken, comments));
        },
        updateLogEntry: (id, centerId, dashRegistrationId, actionTaken, comments) => {
            return dispatch(DashCenterActionCreators.updateLogEntry(id, centerId, dashRegistrationId, actionTaken, comments));
        },
        deleteLogEntry: (centerId, dashRegistrationId, id) => {
            return dispatch(DashCenterActionCreators.deleteLogEntry(centerId, dashRegistrationId, id));
        },
        getDonorCenterLogEntries: (centerId, regId, isAdmin) => {
            return dispatch(DashCenterActionCreators.getDashCenterLogEntries(centerId, regId, isAdmin));
        },
        sendConfirmEmail: (request) => {
            return dispatch(DashCenterActionCreators.sendConfirmEmail(request));
        },
        markJugAsArrived: (donorId, arrivalDate) => {
            return dispatch(DashCenterActionCreators.markJugAsArrived(donorId, arrivalDate));
        },
        updateDonorDetails: (id, detailRequest) => {
            return dispatch(DashCenterActionCreators.updateDonorDetails(id, detailRequest));
        },
        updateDisposition: (id, detailRequest) => {
            return dispatch(DashCenterActionCreators.updateDisposition(id, detailRequest));
        },
        updateComments: (id, detailRequest) => {
            return dispatch(DashCenterActionCreators.updateComments(id, detailRequest));
        },
        enrollExpertSystem: (registrationId, bulkType, alias, medicalRecordId) => {
            return dispatch(DashCenterActionCreators.enrollExpertSystem(registrationId, bulkType, alias, medicalRecordId));
        },
        checkDonorProfile: (registrationId) => {
            return dispatch(DashCenterActionCreators.checkDonorProfile(registrationId));
        },
        getLabResultsNotCombined: (registrationId) => {
            return dispatch(DashCenterActionCreators.getLabResultsNotCombined(registrationId));
        },
        getLabResultsCombined: (registrationId) => {
            return dispatch(DashCenterActionCreators.getLabResultsCombined(registrationId));
        },
        sendPediatricGalleryEmail: (centerId, registrationId) => {
            return dispatch(DashCenterActionCreators.sendPediatricGalleryEmail(centerId, registrationId));
        },
        donorDetailsPrint: (centerId, regId) => {
            return dispatch(DashCenterActionCreators.donorDetailsPrint(centerId, regId));
        },
        handleLoginAs: (registrationId) => {
            return dispatch(DashCenterActionCreators.handleLoginAs(registrationId));
        },
        validateExpertSystemEnrollment: (registrationId, alias) => {
            return dispatch(DashCenterActionCreators.validateExpertSystemEnrollment(registrationId, alias));
        },
        getRecipientCenterCoordList: (centerId) => {
            return dispatch(DashCenterActionCreators.getRecipientCenterCoordList(centerId));
        },
        updateRecipientCenterCoord: (centerId, donorId, coordinatorId) => {
            return dispatch(DashCenterActionCreators.updateRecipientCenterCoord(centerId, donorId, coordinatorId));
        },
        getLabOrder: (registrationId) => {
            return dispatch(DashCenterActionCreators.getLabOrder(registrationId));
        },
        uploadLabs: (registrationId, file) => {
            return dispatch(DashCenterActionCreators.uploadLabs(registrationId, file));
        },
        convertToDirectToCenter: (registrationId, centerId) => {
            return dispatch(DashCenterActionCreators.convertToDirectToCenter(registrationId, centerId));
        },
        restartPwl: (registrationId, isCystatinC) => {
            return dispatch(DashCenterActionCreators.restartPwl(registrationId, isCystatinC));
        },
        expireDonor: (registrationId, centerId) => {
            return dispatch(DashCenterActionCreators.expireDonor(registrationId, centerId));
        },
        optOutDonor: (registrationId, centerId) => {
            return dispatch(DashCenterActionCreators.optOutDonor(registrationId, centerId));
        },
        reverseRuleOut: (registrationId) => {
            return dispatch(DashCenterActionCreators.reverseRuleOut(registrationId));
        },
        getDonorDetails: (centerId, regId) => {
            return dispatch(DashCenterActionCreators.getDonorDetails(centerId, regId));
        },
        getPedsMicrositeByCenter: (centerId) => {
            return dispatch(MicrositeActionCreators.getPedsMicrositeList(centerId));
        },
        convertDonor: (data) => {
            return dispatch(MicrositeActionCreators.convertDonor(data));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(AllDonors);